/*
    format {
        label: reference to qResultsLang for label,
        optional: Boolean => If true, adds Optional text.
        l: length of element: 'full', 'half', or 'third',
        model: reference to data model from application-img.js
        maxlength: max length of input,
        type: 'input' 'select' or 'datepicker'
        additionalClasses: For indexing purposes on o-Valid-msg div. See mounted hook step 3 for hiding validations while typing.
        modal: modal key
        liveErrors: When set to true, makes validations show on dirty rather than true.
                    Must set touch at @change on input and ensure checks are correct in the children of o-Valid-msg
        validations: [
            {name: name of vuelidate validation included in validations on object on the app's js file.
             text: qResultsLang language key from the errors section in the object}.
        ]
        conditions: Write JS that will return true or false... Will display if true, or not if false.,
                    eval is called inside input-section, so can target data/props in input-section
                    i.e. data is a prop passed to input-section: 'this.data.application.planId > 0'
        selectOptions: text and value for select drops downs selectOptions: [
                {text: "Type 1", value: "type1"},
                {text: "Type 1", value: "type1"},
                {text: "Type 1", value: "type1"}
            ],
        imageInInput: img src for fixed images within inputs (such as in the checking input step 5 IMG)
    }
*/

//Missing Plan Ids for Patriot Multitrip America/International
const homeCountryPlans = [1,319,320,751,752,401,402,311,312,557,558];
export { homeCountryPlans }

let showHomeCountry = ibJS.application && homeCountryPlans.indexOf(ibJS.application.planId) > -1;

export default {
    //STEP 1
    coverageDates: [
        {
            label: '',
            l: 'half',
            model: 'startDate',
            id: 'start',
            maxlength: 10,
            type: 'datepicker',
            modal: null,
            additionalClasses: ['start-check'],
            validations: [
                {name: 'required', text: 'startDateRequired'},
                {name: 'numbersWithDashSlash', text: 'alphaNumeric'},
                {name: 'noAlphabets', text: 'noAlphabets'},
                {name: 'checkDateFormat', text: 'invalidStartDateFormat'},
                {name: 'dateNotInPast', text: 'startDateNotPriorToToday'},
                {name: 'monthDate', text: 'invalidStartDateFormat'}
            ],
            conditions: true,
            placeholder: window.qResultsLang.startDate
        },
        {
            label: '',
            l: 'half',
            model: 'endDate',
            id: 'end',
            maxlength: 10,
            modal: null,
            type: 'datepicker',
            additionalClasses: ['end-check'],
            validations: [
                {name: 'required', text: 'endDateRequired'},
                {name: 'numbersWithDashSlash', text: 'alphaNumeric'},
                {name: 'noAlphabets', text: 'noAlphabets'},
                {name: 'checkDateFormat', text: 'invalidEndDateFormat'},
                {name: 'isAfterStartDate', text: 'endDateAfterStartDate'},
                {name: 'monthDate', text: 'invalidEndDateFormat'}
            ],
            conditions: true,
            placeholder: window.qResultsLang.endDate
        }
    ],
    //STEP 3
    contactInformation: [
        {
            label: 'email',
            labelId: 'email1Label',
            l: 'half',
            model: 'primaryEmail',
            id: 'email',
            maxlength: 45,
            type: 'email',
            additionalClasses: ['email-check'],
            modal: "email",
            liveErrors: true,
            validations: [
                {name: 'required', text: 'emailRequired'},
                {name: 'alphaNumericInsubuyIMG', text: 'alphaNumeric'},
                {name: 'emailIMG', text: 'invalidEmail'},
                {name: 'affiliateValid', text: 'affiliateEmail'}
            ],
            conditions: true
        },
        {
            label: 'phoneNumber',
            l: 'half',
            model: 'phoneNumber',
            phoneId: 'phnCode',
            id: 'phoneNumber',
            maxlength: 250,
            type: 'phone',
            modal: "phonenumber",
            countryCodeModel: 'countryCode',
            additionalClasses: ['phnCode-check'],
            validations: [
                {name: 'required', text: 'phoneRequired'},
                {name: 'onlyDashAndNumbers', text: 'alphaNumeric'},
                { name: 'min10DigitsPhone', text: 'phoneMin10Digits' },
                { name: 'min7DigitsPhone', text: 'phoneMin7Digits' }
            ],
            conditions: true
        },
    ],
    priorInsuranceDetails: [
        {
            label: 'internationalInsuranceProvider',
            labelId: 'internationalInsuranceProviderLabel',
            l: 'half',
            model: 'internationalInsuranceProvider',
            id: 'internationalInsuranceProvider',
            maxlength: 250,
            type: 'input',
            modal: 'internationalinsuranceprovider',
            additionalClasses: [],
            validations: [
                {name: 'requireIfDisplayed', text: 'iipRequired'},
                {name: 'alphaNumericInsubuyIMG', text: 'alphaNumeric'}
            ],
            conditions: true
        },
        {
            label: 'expirationOfCurrentCoverage',
            labelId: 'expirationOfCurrentCoverageLabel',
            l: 'half',
            model: 'intlInsuranceExpDate',
            id: 'expiration',
            maxlength: 10,
            modal: "expirationdatecurrentcoverage",
            type: 'datepicker',
            additionalClasses: [],
            //check text for expiryfromstartdate
            validations: [
                {name: 'requireIfDisplayed', text: 'expOfCurrentCoverageRequred'},
                {name: 'monthDate', text: 'invalidExpCurrentCoverage'}
            ],
            conditions: true
        }
    ],
    //STEP 5
    checkingInformation: [
        {
            label: 'accountType',
            l: 'half',
            model: 'accountType',
            id: 'accountType',
            maxlength: 250,
            type: 'select',
            modal: 'accounttype',
            selectOptions: [
                {text: 'commericalCheckingAccount', value: "1"},
                {text: 'consumerCheckingAccount', value: "2"},
                {text: 'consumerSavingsAccount', value: "3"}
            ],
            additionalClasses: [],
            validations: [
                {name: 'required', text: 'accountTypeRequired'}
            ],
            conditions: true
        },
        {
            label: 'nameOnAccount',
            l: 'half',
            model: 'ccName',
            maxlength: 250,
            modal: "nameonaccount",
            type: 'input',
            additionalClasses: [],
            validations: [
                {name: 'required', text: 'nameOnAccountRequired'},
                {name: 'nameRegexInsubuyIMG', text: 'nameFormat'}
            ],
            conditions: true
        },
        {
            label: 'routingNumber',
            l: 'half',
            model: 'bankRoutingNum',
            id: 'routingNumber',
            maxlength: 250,
            modal: "routingnumber",
            type: 'input',
            additionalClasses: ['routingNumber-check'],
            validations: [
                {name: 'required', text: 'routingNumberRequired'},
                {name: 'onlyAlphaNumeric', text: 'invalidCharacterRoutingNumber'},
                {name: 'IMGRoutingNumber', text: 'invalidRoutingNumber'}
            ],
            conditions: true
        },
        {
            label: 'accountNumber',
            l: 'half',
            model: 'bankAcctNum',
            id: 'expiration',
            maxlength: 250,
            modal: "accountnumber",
            type: 'input',
            additionalClasses: [],
            validations: [
                {name: 'required', text: 'accountNumberRequired'},
                {name: 'onlyAlphaNumeric', text: 'alphaNumeric'}
            ],
            conditions: true,
            imageInInput: '/assets/img/credit-cards/cc-9.svg'
        }
    ],
    signatureOfApplicant: [
        {
            label: 'applicantSignature',
            l: 'half',
            model: 'signature',
            modal: 'signature',
            id: 'accountType',
            maxlength: 250,
            type: 'input',
            additionalClasses: [],
            validations: [
                {name: 'required', text: 'applicantSignatureRequired'},
                {name: 'nameRegexInsubuyIMG', text: 'invalidSignatureFormat'}
            ],
            conditions: true
        },
        {
            label: 'date',
            l: 'half',
            model: 'todaysDate',
            modal: 'todaysDate',
            maxlength: 250,
            type: 'input',
            additionalClasses: [],
            validations: [],
            conditions: true,
            disabled: true,
        },
        // {
        //     label: 'relationshipToApplicant',
        //     l: 'half',
        //     model: 'relToApplicant',
        //     id: 'relToApplicant',
        //     maxlength: 250,
        //     type: 'input',
        //     additionalClasses: [],
        //     validations: [
        //         {name: 'requiredIf16', text: 'relationshipToApplicantRequired'},
        //         {name: 'nameRegexInsubuyIMG', text: 'invalidRelToAppFormat'}
        //     ],
        //     conditions: ibJS.application && ibJS.primaryBelow16
        // }
    ]
};
